import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import OrbLoader from "../components/common/OrbLoader";
import { useDispatch, useSelector } from "react-redux";
import { setToastMessage } from "../store/slices/app/appSlice";
import { selectSidebarCollapsed } from "../store/slices/app/appSelector";
import { useTranslation } from "react-i18next";
import CampaignTable from "../components/table/CampaignTable";
import MetricsCampaignDetailsPanel from "../components/campaign/MetricsCampaignDetailsPanel";
import { useGetUserDbCampaignsQuery } from "../store/apis/campaignApi";
import EmptyState from "../components/EmptyState";
import PageBreadcrumbs from "../components/layout/PageBreadcrumbs";

const Metrics: React.FC = () => {
  const collapsed = useSelector(selectSidebarCollapsed);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Fetch campaigns from API
  const {
    data: campaignsData,
    isLoading: isLoadingCampaigns,
    error: campaignsError,
  } = useGetUserDbCampaignsQuery();

  // Show error toast if there's an error fetching campaigns
  useEffect(() => {
    if (campaignsError) {
      dispatch(
        setToastMessage({
          message: t("metrics.errors.fetchError"),
          severity: "error",
        })
      );
    }
  }, [campaignsError, dispatch, t]);

  return (
    <Box sx={{ display: "flex" }}>

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          transition: "margin-left 0.3s ease",
          marginLeft: collapsed ? "64px" : "250px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <PageBreadcrumbs />

        {isLoadingCampaigns ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <OrbLoader
              size="large"
              label={t("common.loading", { defaultValue: "Cargando…" })}
            />
          </Box>
        ) : campaignsError ||
          !campaignsData?.data ||
          campaignsData.data.length === 0 ? (
          <EmptyState
            title={t("home.emptyStates.noCampaigns.title")}
            message={t("home.emptyStates.noCampaigns.message")}
            buttonText={t("home.emptyStates.noCampaigns.buttonText")}
            buttonLink="/campaigns/new"
          />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography variant="h3" gutterBottom>
                  {t("metrics.title", "Metrics")}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                mt: 3,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="h4" gutterBottom>
                  {t("campaigns.assigned", {
                    num: campaignsData?.data?.length || 0,
                  })}
                </Typography>
                <Typography variant="pSmall">
                  {t("campaigns.active", {
                    num: campaignsData?.data ? campaignsData.data.length : 0,
                  })}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ mt: 3 }}>
              <CampaignTable
                campaignsData={campaignsData?.data || []}
                showActions={false}
                renderExpandedContent={(campaign) => (
                  <MetricsCampaignDetailsPanel campaign={campaign} />
                )}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Metrics;
